import * as React from "react";

import { DrawerView } from "../../Common";

import { DrawerFragment_OutOfOStock_ViewModel } from "./drawer-fragment-out-of-stock-view-model";
import { DrawerFragment_OutOfStock_Content } from "./drawer-content-out-of-stock";

export const DrawerFragment_OutOfStock: React.FunctionComponent = (props) => {
  return (
    <React.Fragment>
      <DrawerView useDrawerViewModel={DrawerFragment_OutOfOStock_ViewModel}>
        <DrawerFragment_OutOfStock_Content />
      </DrawerView>
    </React.Fragment>
  );
};
